import React, {Fragment} from 'react';
import { 
    Filter,
    List, 
    Datagrid,
    TextField, 
    DateField,
    TextInput,
    EditButton,
    CardActions,
    ListButton,
    SimpleShowLayout,
    Show,
    ShowButton,
    Edit,
} from 'react-admin';
import { Redirect } from 'react-router-dom';
import LinkToCreate from './LinkToCreate'
import ViewDetails from './ViewDetails'
import moment from 'moment'

var uid = null;

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

export const NameFilter = props => (
    <Filter {...props}>   
        <TextInput source="name" alwaysOn label='Name'/>
    </Filter>
);

const Actions = ({...props}) => (
    <CardActions style={cardActionStyle}>
        <LinkToCreate uid={props.filterValues.uid} />
        <ListButton basePath={'/userslist'} label="User List" />
        
    </CardActions>
);

const Heading=({data})=>{
    return (<h3>{data}</h3>)
}


const PostShow = props => (
    <Show
        {...props}

        title=" "
    >
        <SimpleShowLayout>
        <table width="90%" >
                    <tbody>
                        <tr>
                            <td width="20%">Employee Name:</td><td colSpan="3">{(props.record && props.record.emp_name)}</td>
                           
                        </tr>
                        <tr>
                            <td width="20%">Employee Titile:</td><td colSpan="3">{(props.record && props.record.emp_title)}</td>
                           
                        </tr>
                        <tr><td  colSpan="4">&nbsp;</td></tr>
                        <tr>
                        <td colSpan="4">
                            <table border="1" cellSpacing="0" style={{ width:"100%"}}>
                                <tbody>
                                    <tr>
                                        <th style={{backgroundColor: "silver", fontWeight: "bold", width:"60%", textAlign: "center"}}>Procedure</th>
                                        <th style={{backgroundColor: "silver", fontWeight: "bold", width:"15%", textAlign: "center"}}>Date of Reading</th>
                                        <th style={{backgroundColor: "silver", fontWeight: "bold", width:"10%", textAlign: "center"}}>Employee Initial</th>
                                        <th style={{backgroundColor: "silver", fontWeight: "bold", width:"15%", textAlign: "center"}}>Date</th>
                                    </tr>
                                    <ViewDetails records={props.record}  />  
                                </tbody>
                            </table>
                    
                        </td>
                        </tr>
                        <tr><td  colSpan="4">&nbsp;</td></tr>
                        {
                        (props.record && props.record.isphy_sub )?(
                        <Fragment>
                        <tr>
                            <td  colSpan="4">
                            <table border="1" cellSpacing="0" style={{ width:"100%"}}>
                            <tbody>
                                <tr>
                                    <td>
                                        <table style={{ width:"100%"}}>
                                        <tbody>
                                            <tr>
                                                <td colSpan="4"><b>For Physician Substitute ONLY</b></td>
                                            </tr>
                                            <tr>
                                                <td colSpan="2">Physical Examination performed in presence of CMD on Date:</td>
                                                <td>{(props.record && props.record.cmd_date && moment(props.record.cmd_date).format('MM/DD/yyyy'))}</td>
                                                <td>&nbsp;</td>
                                            </tr>
                                            <tr>
                                                <td colSpan="4">
                                                <u>CMD Comments:</u>{(props.record && props.record.cmd_comments)}
                                                
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Center Medical Director Signature:</td>
                                                <td>{(props.record && props.record.cmd_sign)}</td>
                                                <td>&nbsp;Date:</td>
                                                <td>{(props.record && props.record.cmd_sign_date && moment(props.record.cmd_sign_date).format('MM/DD/yyyy'))}</td>
                                            </tr>
                                        </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                            </table>
                            </td>
                        </tr>
                        <tr><td  colSpan="4">&nbsp;</td></tr>
                        </Fragment>): null
                        }
                <tr>
                    <td colSpan="4">
                        <table width="100%">
                            <tbody>
                                <tr>
                                    <td>Employee Name:</td><td>{(props.record && props.record.emp_name)}</td>
                                    <td>Signature:</td><td>{(props.record && props.record.emp_sign)}</td>
                                    <td>Date:</td><td>{(props.record && props.record.emp_sign_date  && moment(props.record.emp_sign_date).format('MM/DD/yyyy') )}</td>
                                </tr>
                                <tr>
                                    <td>Management/QA review:</td><td>{(props.record && props.record.qa_review)}</td>
                                    <td>Signature:</td><td>{(props.record && props.record.qa_sign)}</td>
                                    <td>Date:</td><td>{(props.record && props.record.qa_sign_date && moment(props.record.qa_sign_date).format('MM/DD/yyyy'))}</td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>

                </tbody>
            </table>

        </SimpleShowLayout>
    </Show>
);



const Status=({record})=>(
    (record && record.qa_sign && record.qa_sign > ' ') ? <span style={{color: 'green'}}>Completed</span> : <span style={{color: 'orange'}}>Progress</span>
);

const CustomEditButton=({record,basePath})=>(
    (record && record.qa_sign && record.qa_sign > ' ') ? <span></span> :  <EditButton  record={record} basePath={basePath}/>
);

const GetKey=({ props }) => (
    //console.log(props),
    uid = (props.location)?( (props.location.uid)?props.location.uid:uid):uid,
    (uid)? '': <Redirect to="/userslist" />
);

export const CheckListFull = props => (
    <List 
        {...props}
        filters={<NameFilter />}
        actions={<Actions/>} 
        perPage={20}
        sort={{ field: 'name', order: 'ASC' }}
        bulkActionButtons ={false}
       
        >
        <Datagrid   expand={<PostShow />}>
            <GetKey props ={props} />
            <TextField source="name" label="Name" />
            <DateField source="created_date" label="Date"  locales="en-us" />
            <Status  label="Status" />
            <CustomEditButton  />
            <ShowButton />
        </Datagrid>
    </List>
);


export default CheckListFull